import React, {
  Component
} from 'react';


export default class AssessementViewList extends Component {


  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {

   const {data}=this.props;
    return (
     <div className="grey-lite">
    <span className="bluetxt">This component will be rated/viewed by</span>
    <div className="cwrespage">
    <table width="100%" cellPadding="0" cellSpacing="0" id="view" className="myjourney-table descriptive"  border="0">
    <thead>
      <tr>
        <th>Name</th>
        <th>Score</th>
        <th>Assessed on</th>
        <th>Remarks</th>
      </tr>
      </thead>

      {data.length>0 &&
       <tbody>
       {data.map((key,i)=>
         <tr key={`assesment_${i}`}>
         <td>{key.name}</td>
         <td>{key.score}</td>
         <td>{key.assessed_on}</td>
         <td>{key.remark}</td>
         </tr>
      )}
      </tbody>
     }
      </table>
      </div>
      {data.length==0 &&
      <div className="abbrevation margbtm">
       	<ul>
          <li><strong>YTA</strong> - Yet to Assess</li>
          <li><strong>NA</strong> - Not Applicable, only for View.</li>
          </ul>
        </div>
      }
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/lr_dlr_components/partials/AssessementViewList.js